import "./cafm.base.jsx";
import "./cafm.url.jsx";
import "./cafm.global.jsx";
import "./cafm.dom.jsx";
import "./cafm.util.jsx";
import "./cafm.kendo.extensions.jsx";
import "./cafm.enums.jsx";
import "./cafm.browsers.jsx";
import "./cafm.browsers.bbmobile.jsx";
import "./cafm.browsers.iemobile.jsx";
import "./cafm.cache.jsx";
import "./cafm.views.jsx";
import "./cafm.bindings.jsx";
import "./cafm.actions.jsx";
import "./cafm.nav.jsx";
import "./cafm.router.jsx";
import "./cafm.panel.jsx";
import "./cafm.forms.jsx";
import "./cafm.datasource.jsx";
import "./cafm.auth.jsx";
import "./cafm.handlers.jsx";
import "./cafm.web.jsx";
import "./cafm.layout.jsx";
import "./cafm.ready.jsx";
import "./cafm.load.jsx";
import "./cafm.timezone.jsx";